import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {currentScreen} from '/redux/selector/navigation.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {clientsToContactNumberForCurrentTab} from '/redux/selector/report.selector';

import {PeopleToContactSection} from './PeopleToContactSection';

export default connect(
  createStructuredSelector({
    clientsToContactNumberForCurrentTab,
    currentScreen,
    featureFlag: variablesFeatureFlag,
  }),
)(PeopleToContactSection);
